// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"68fe1633bd9e27027730","186":"7bb131a4efd227472059","454":"5922d0395fbbde6e2dd5","812":"edea13854c7f63f48f81"}[chunkId] + ".chunk.js";
};